import { formatDate } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Language } from '../../language';

export class DatesHelper {
    protected constructor() {
    }

    static formatDate(value: string | number | Date, format: string): string {
        return formatDate(value, format, Language.English);
    }

    static getViewDateFormat(language: string): string {
        return language === Language.Bulgarian
            ? environment.dateViewFormatBulgarian
            : environment.dateViewFormat;
    }

    static getShortDateFormat(): string {
        return environment.dateShortFormat;
    }

	static getDateAndTimeFormat(): string {
		return environment.dateAndTimeFormat;
	}

    static getDatePickerFormat(language: string): string {
        return language === Language.Bulgarian
            ? environment.datePickerFormatBulgarian
            : environment.datePickerFormat;
    }

	static getDaysBetweenDates(dateFirst: Date, dateSecond: Date) {
		const diff = dateSecond.getTime() - dateFirst.getTime();
		const days = Math.floor(diff / (1000 * 60 * 60 * 24));
		return Math.abs(days);
	}


	static getYearsBetweenDates(dateFirst: Date, dateSecond: Date) {
		const days = DatesHelper.getDaysBetweenDates(dateFirst, dateSecond);
		const years = days / 365;
		return years;
	}
}
